import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, inject, Inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { FooterModule } from '@app/components/footer/footer.module';
import { HeaderModule } from '@app/components/header/header.module';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { MediaService } from '@app/services/media.service';
import { UiOfferService } from '@app/services/uioffer.service';
import { Bosyscontact } from '../bosyscontact/bosyscontact';
import { Bosyshotellist } from '../bosyshotellist/bosyshotellist';
import { Bosyshotel } from '../bosyshotel/bosyshotel';
import { MatIconModule } from '@angular/material/icon';
import { CleverMapcomponentComponent } from '@app/components/map/mapcomponent/mapcomponent.component';
import { Bosysreview } from '../bosysreview/bosysreview';
import { Bosysbooking } from '../bosysbooking/bosysbooking';
import { Bosysimagelist } from '../bosysimagelist/bosysimagelist';
import { DEFAULT_PARTNER_ID } from '@app/components/tools/Const';

@Component({
    selector: 'clever-bosysdetail',
    imports: [
        CommonModule,
        FooterModule,
        HeaderModule,
        MatProgressSpinner,
        Bosyshotellist,
        Bosyshotel,
        Bosyscontact,
        Bosysreview,
        Bosysimagelist,
        Bosysbooking,
        CleverMapcomponentComponent,
        MatIconModule
    ],
    templateUrl: './bosysdetail.html',
    styleUrl: './bosysdetail.scss'
})
export class Bosysdetail implements OnInit {
    isBrowser = signal<boolean>(false);
    loading = signal<boolean>(true);
    details = signal<any[]>([]);
    offerid = signal<string>('');
    recid = signal<number>(0);

    location = signal<string>('');
    name = signal<string>('');
    categoryAr = signal<number[]>([]);
    images = signal<string[]>([]);
    topimages = signal<string>('');

    myoffice = signal<any>(null);
    myoffer = signal<any>(null);
    form = signal<any>(null);
    person = signal<any>(null);
    offerslist = signal<any>(null);

    partner: Partner;
    destroyRef = inject(DestroyRef);
    constructor(
        protected mediaService: MediaService,
        protected uiOfferService: UiOfferService,
        protected route: ActivatedRoute,
        @Inject(PLATFORM_ID) protected platformId: any,
        protected guardService: AuthGuardService,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.isBrowser()) {
            this.initPartner();
        }
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.partner = partner;
                this.initFilters();
            }
        });
    }

    async initFilters() {
        // console.log(this.route.snapshot.params['recid'], this.route.snapshot.params['offerid']);
        if (this.route.snapshot.params['offerid']) {
            this.offerid.set(this.route.snapshot.params['offerid']);
            this.recid.set(Number(this.route.snapshot.params['recid']));
            const target = {
                token: this.offerid(),
                recid: String(this.recid())
            }
            this.uiOfferService.request(target, 'getOfferDetail').pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(offers => {
                if (offers?.bns_response) {
                    if (offers?.partnerid === this.partner.partnerid) {
                        this.setDatas(offers);
                        this.setOfficePerson(offers);
                    } else {
                        this.guardService.resetpartnerincookie(offers?.partnerid === DEFAULT_PARTNER_ID ? '' : (offers?.partnerid?.length > 0 ? offers?.partnerid : ''));
                    }
                }
            });
        } else {
            this.loading.set(false);
        }
    }

    async setDatas(offers: any) {
        // console.log(offers)
        this.myoffer.set(offers?.bns_response?.GetOfferDetail?.offer);
        this.form.set(offers?.form);
        this.details.set(offers?.bns_response?.GetOfferDetail?.offer?.details);
        // console.log(this.form())

        for (let i = 0; i < this.details().length; i++) {

            switch (this.details()[i].heading) {
                case 'Details':
                    this.setDetail(this.details()[i]);
                    break;

                default:
                    break;
            }

        }
        this.loading.set(false);
    }

    async setDetail(head) {
        for (let j = 0; j < head?.xinfos.length; j++) {
            switch (head?.xinfos[j]?.type) {
                case 'text':
                    if (this.location()?.length > 0) {
                        this.name.set(head?.xinfos[j].content);
                    } else {
                        this.location.set(head?.xinfos[j].content);
                    }

                    break;
                case 'image':
                    this.topimages.set(head?.xinfos[j].content);

                    break;
                case 'stars':
                    const catg = head?.xinfos[j].content / 10;
                    for (let i = 0; i < Math.floor(catg); i++) {
                        this.categoryAr().push(1);
                    }
                    if (catg > Math.floor(catg)) {
                        this.categoryAr().push(0.5);
                    }

                    break;

                default:
                    break;
            }
        }
    }


    async setOfficePerson(offers: any) {
        // console.log(offers);
        this.person.set(offers?.offers?.offer);
        this.offerslist.set(offers?.offers?.recommendations);
        if (offers.office) {
            this.myoffice.set(offers?.office?.MyOffice);
        }
        // console.log(this.myoffice());
        // console.log(this.person());
        this.loading.set(false);
    }

    async gotobutton(elm) {
        setTimeout(() => {
            elm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
    }
}
